import React from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import Settings from "../private/pages/settings";
import BookingPage from "../public/booking";
import Imprint from "../public/imprint";
import Login from "../public/login";
import { isPayHost, isShortHost, PayLocation, PayStart } from "../public/pay";
import MyBookings from "../public/my";
import Page404 from "../public/page404";
import Privacy from "../public/privacy";
import SearchPage from "../public/search";
import SitePage from "../public/site";
import SuccessPage from "../public/success";

// Alte Buchungslinks (/checkout/:id) führen zur neuen Standortseite
const LegacyCheckout = () => {
  const { parkingId } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/p/${encodeURIComponent(parkingId)}${search}`} replace />;
};

const PageRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* go.innopark24.de/<Parkplatz> = Bezahlseite (QR-Code am Schild); pay.<domain> startet direkt mit Bezahlen */}
        <Route path="/" element={isPayHost() ? <PayStart /> : <Login />} />
        {isShortHost() && <Route path="/:id" element={<PayLocation />} />}
        {/* Digital bezahlen vor Ort (Ziel der QR-Codes): /pay/<Parkplatz> */}
        <Route path="/pay" element={<PayStart />} />
        <Route path="/pay/:id" element={<PayLocation />} />
        <Route path="/vor-ort" element={<Login />} />
        <Route path="/search" element={<SearchPage />} />
        {/* Standortseite – auch Ziel der QR-Codes am Parkplatz: /p/<id>?qr=1 */}
        <Route path="/p/:id" element={<SitePage />} />
        <Route path="/buchen/:id/:tariffId" element={<BookingPage />} />
        <Route path="/erfolg" element={<SuccessPage />} />
        <Route path="/meine-buchungen" element={<MyBookings />} />
        <Route path="/checkout/:parkingId" element={<LegacyCheckout />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default PageRouter;
